import languageData from "../languages.json"

export const fetchAudioText = async (
    {
        audioData,
        defaultCampaigns,
        selectedCategory,
        campaignDescription,
        language,
        setEditableTextAudio,
        setAudioText,
        setCurrentBalance,
        setSpinning,
        getToken,
        configData,
        navigate,
        notify,
        setFetchAudioTextStatus,
    }
) => {
      // await sleep(2000);
      // return false
      if(audioData){
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        try {
          let audioBody = audioData
          let langValue = languageData.LANGUAGE_DICT[language]
          if(campaignDescription !== ""){
                  audioBody = {
                  ...audioData,
                  offer_id: `AudioText_${audioData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
                  offer_details: campaignDescription.split("\n").join(" "),
                  language: langValue
                }
            }
          else{
            audioBody = {
                  ...audioData,
                  offer_id: `AudioText_${audioData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
                  language: langValue,
                  offer_details: `${defaultCampaigns[selectedCategory].Product_title} ${defaultCampaigns[selectedCategory].Price}. ${defaultCampaigns[selectedCategory].Description ? defaultCampaigns[selectedCategory].Description : ""}. ${defaultCampaigns[selectedCategory].Disclaimer ? defaultCampaigns[selectedCategory].Disclaimer : ""}`,
                }
            }
          const token = getToken()
          const res = await fetch(`${configData.DEMO_URL}/CreateAudioText`, {
            method: "POST",
            headers: {
                "x-access-token": token,
                "Content-Type": "application/json",
                // add auth token if needed
              },
            body: JSON.stringify(audioBody),
          });
    
          if (!res.ok) {
            let errorMessage = `Request failed (${res.status})`;

            try {
              const errorBody = await res.json();
              if (errorBody?.message) {
                errorMessage = errorBody.message;
              }
            } catch (_) {
            }

            const error = new Error(errorMessage);
            error.status = res.status;
            throw error;
          }

        const response = await res.json();
        setEditableTextAudio(response.audio_text);
        setAudioText(response.audio_text)
        setCurrentBalance(response.current_balance)
        setSpinning(prev => ({ ...prev, ["audio_text"]: false }));
        setFetchAudioTextStatus(false);
        return response.audio_text; 
          // setAudioUrl("https://storage.googleapis.com/staging_catch_assets/campaign_audio/1123.wav")
          // setloading(false)
          // return false
    
          // return data; // data should have the same shape as your previous `response.data`
        } catch (error) {
          if (error.status === 401 || error.status === 403) {
            navigate("/");
          } else {
            notify(error.message, "error");
          }

          setSpinning(prev => ({ ...prev, ["audio"]: false }));
          setSpinning(prev => ({ ...prev, ["audio_text"]: false }));
          setFetchAudioTextStatus(false);
          return false;
        }
      }
      else{
        notify("No audio data found", "error");
        setSpinning(prev => ({ ...prev, ["audio"]: false }));
        setSpinning(prev => ({ ...prev, ["audio_text"]: false }));
        setFetchAudioTextStatus(false);
        return false
      }
    };